// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.MainHeroSection_hero__P\\+GV8 {
  position: relative;
  min-height: 700px;
  height: 86dvh;
  overflow: hidden;
  background: #000;
  display: flex;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
.MainHeroSection_hero__video__DXRlD {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.MainHeroSection_hero__overlay__MBZif {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(12, 22, 18, 0.46) 0%, rgba(12, 22, 18, 0.34) 36%, rgba(12, 22, 18, 0.6) 68%, rgba(12, 22, 18, 0.78) 100%), radial-gradient(circle at 42% 40%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.03) 28%, rgba(255, 255, 255, 0) 58%), linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.46) 100%);
  z-index: 1;
}
.MainHeroSection_hero__content__bLyh2 {
  position: absolute;
  right: 4vw;
  top: 50%;
  transform: translateY(-50%);
  width: min(520px, 37vw);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  color: #fff;
  z-index: 2;
}
@media (max-width: 980px) {
  .MainHeroSection_hero__content__bLyh2 {
    width: min(620px, 100% - 64px);
    left: 50%;
    right: auto;
    transform: translate(-50%, -50%);
    align-items: center;
    text-align: center;
  }
}
@media (max-width: 720px) {
  .MainHeroSection_hero__content__bLyh2 {
    width: min(100vw - 40px, 560px);
    left: 50%;
    right: auto;
  }
}
.MainHeroSection_hero__title__bDWTZ {
  margin: 0 0 16px;
  font-size: clamp(54px, 4.2vw, 68px);
  line-height: 1;
  letter-spacing: -0.045em;
  font-weight: 700;
  color: #fff;
}
.MainHeroSection_hero__title__bDWTZ span {
  display: block;
}
@media (max-width: 720px) {
  .MainHeroSection_hero__title__bDWTZ {
    font-size: 40px;
  }
  .MainHeroSection_hero__title__bDWTZ span {
    white-space: normal;
  }
}
.MainHeroSection_hero__sub__ivWUA {
  max-width: 540px;
  margin: 0 0 36px;
  font-size: 16px;
  line-height: 1.65 !important;
  color: rgba(255, 255, 255, 0.95);
}
@media (max-width: 1015px) {
  .MainHeroSection_hero__sub__ivWUA {
    font-size: 17px;
    line-height: 1.45;
    max-width: none;
  }
}
.MainHeroSection_hero__cta-group__RhMdc {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  max-width: 403px;
}
@media (max-width: 980px) {
  .MainHeroSection_hero__cta-group__RhMdc {
    align-items: center;
    max-width: none;
  }
}
.MainHeroSection_hero__cta__hwcoC {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  min-width: 214px;
  padding: 0 24px;
  background: #82B194;
  color: #fff;
  border-radius: 16px;
  border: none;
  cursor: pointer;
  box-shadow: 0 12px 24px rgba(113, 157, 130, 0.18);
  transition: background 0.15s ease, transform 0.15s ease;
  font-size: 16px;
  line-height: 1;
  font-weight: 600;
  letter-spacing: -0.01em;
}
.MainHeroSection_hero__cta__hwcoC:hover {
  background: #719D82;
  transform: translateY(-1px);
}
.MainHeroSection_hero__note__MrkP5 {
  margin: 0;
  margin-top: 14px;
  font-size: 13px;
  line-height: 1.38;
  color: rgba(255, 255, 255, 0.78);
  font-size: 14px !important;
  line-height: 1.5 !important;
  font-weight: 400 !important;
  width: 250px;
}
.MainHeroSection_hero__note__MrkP5 span {
  display: block;
}
@media (max-width: 980px) {
  .MainHeroSection_hero__note__MrkP5 {
    width: 100%;
    text-align: center;
  }
  .MainHeroSection_hero__note__MrkP5 span {
    display: inline;
  }
}
.MainHeroSection_hero__note-auth__ri91Z {
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 14px !important;
  line-height: 1.5 !important;
  font-weight: 400 !important;
  max-width: 250px;
}
.MainHeroSection_hero__note-auth__ri91Z span {
  display: block;
}
@media (max-width: 720px) {
  .MainHeroSection_hero__note-auth__ri91Z span {
    display: inline;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Landing/MainHeroSection/MainHeroSection.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oFDHU;ACoBZ;AAfE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAiBJ;AAdE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,wVACI;EAWJ,UAAA;AAKJ;AAFE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AAIJ;AAFI;EAbF;IAcI,8BAAA;IACA,SAAA;IACA,WAAA;IACA,gCAAA;IACA,mBAAA;IACA,kBAAA;EAKJ;AACF;AAHI;EAtBF;IAuBI,+BAAA;IACA,SAAA;IACA,WAAA;EAMJ;AACF;AAHE;EACE,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;AAKJ;AAHI;EACE,cAAA;AAKN;AAFI;EAZF;IAaI,eAAA;EAKJ;EAHI;IACE,mBAAA;EAKN;AACF;AADE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,gCAAA;AAGJ;AADI;EAPF;IAQI,eAAA;IACA,iBAAA;IACA,eAAA;EAIJ;AACF;AADE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAGJ;AADI;EAPF;IAQI,mBAAA;IACA,eAAA;EAIJ;AACF;AADE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBDhHmB;ECiHnB,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,iDAAA;EACA,uDAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAGJ;AADI;EACE,mBAAA;EACA,2BAAA;AAGN;AACE;EACE,SAAA;EACA,gBAAA;EACA,eDxGgB;ECyGhB,iBAAA;EACA,gCAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,YAAA;AACJ;AACI;EACE,cAAA;AACN;AAEI;EAfF;IAgBI,WAAA;IACA,kBAAA;EACJ;EAAI;IACE,eAAA;EAEN;AACF;AAEE;EACE,SAAA;EACA,gCAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,gBAAA;AAAJ;AAEI;EACE,cAAA;AAAN;AAGI;EACE;IACE,eAAA;EADN;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.hero {\n  position: relative;\n  min-height: 700px;\n  height: 86dvh;\n  overflow: hidden;\n  background: #000;\n  display: flex;\n  font-family: $font-main;\n\n  &__video {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &__overlay {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    background: \n        linear-gradient(90deg, rgba(12, 22, 18, .46) 0%, \n        rgba(12, 22, 18, .34) 36%, \n        rgba(12, 22, 18, .60) 68%, \n        rgba(12, 22, 18, .78) 100%), \n        radial-gradient(circle at 42% 40%, \n        rgba(255, 255, 255, .08) 0%, \n        rgba(255, 255, 255, .03) 28%, \n        rgba(255, 255, 255, 0) 58%), \n        linear-gradient(180deg, \n        rgba(0, 0, 0, .10) 0%, \n        rgba(0, 0, 0, .46) 100%);\n    z-index: 1;\n  }\n\n  &__content {\n    position: absolute;\n    right: 4vw;\n    top: 50%;\n    transform: translateY(-50%);\n    width: min(520px, 37vw);\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n    color: #fff;\n    z-index: 2;\n\n    @media (max-width: 980px) {\n      width: min(620px, calc(100% - 64px));\n      left: 50%;\n      right: auto;\n      transform: translate(-50%, -50%);\n      align-items: center;\n      text-align: center;\n    }\n\n    @media (max-width: 720px) {\n      width: min(calc(100vw - 40px), 560px);\n      left: 50%;\n      right: auto;\n    }\n  }\n\n  &__title {\n    margin: 0 0 16px;\n    font-size: clamp(54px, 4.2vw, 68px);\n    line-height: 1.0;\n    letter-spacing: -0.045em;\n    font-weight: 700;\n    color: #fff;\n\n    span {\n      display: block;\n    }\n\n    @media (max-width: 720px) {\n      font-size: 40px;\n\n      span {\n        white-space: normal;\n      }\n    }\n  }\n\n  &__sub {\n    max-width: 540px;\n    margin: 0 0 36px;\n    font-size: 16px;\n    line-height: 1.65 !important;\n    color: rgba(255, 255, 255, 0.95);\n\n    @media (max-width: 1015px) {\n      font-size: 17px;\n      line-height: 1.45;\n      max-width: none;\n    }\n  }\n\n  &__cta-group {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 14px;\n    max-width: 403px;\n\n    @media (max-width: 980px) {\n      align-items: center;\n      max-width: none;\n    }\n  }\n\n  &__cta {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 48px;\n    min-width: 214px;\n    padding: 0 24px;\n    background: $color-primary;\n    color: #fff;\n    border-radius: 16px;\n    border: none;\n    cursor: pointer;\n    box-shadow: 0 12px 24px rgba(113, 157, 130, 0.18);\n    transition: background 0.15s ease, transform 0.15s ease;\n    font-size: 16px;\n    line-height: 1;\n    font-weight: 600;\n    letter-spacing: -.01em;\n\n    &:hover {\n      background: #719D82;\n      transform: translateY(-1px);\n    }\n  }\n\n  &__note {\n    margin: 0;\n    margin-top: 14px;\n    font-size: $font-size-caption;\n    line-height: 1.38;\n    color: rgba(255, 255, 255, 0.78);\n    font-size: 14px !important;\n    line-height: 1.5 !important;\n    font-weight: 400 !important;\n    width: 250px;\n\n    span {\n      display: block;\n    }\n\n    @media (max-width: 980px) {\n      width: 100%;\n      text-align: center;;\n      span {\n        display: inline;\n      }\n    }\n  }\n\n  &__note-auth {\n    margin: 0;\n    color: rgba(255, 255, 255, 0.78);\n    font-size: 14px !important;\n    line-height: 1.5 !important;\n    font-weight: 400 !important;\n    max-width: 250px;\n\n    span {\n      display: block;\n    }\n\n    @media (max-width: 720px) {\n      span {\n        display: inline;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `MainHeroSection_hero__P+GV8`,
	"hero__video": `MainHeroSection_hero__video__DXRlD`,
	"hero__overlay": `MainHeroSection_hero__overlay__MBZif`,
	"hero__content": `MainHeroSection_hero__content__bLyh2`,
	"hero__title": `MainHeroSection_hero__title__bDWTZ`,
	"hero__sub": `MainHeroSection_hero__sub__ivWUA`,
	"hero__cta-group": `MainHeroSection_hero__cta-group__RhMdc`,
	"hero__cta": `MainHeroSection_hero__cta__hwcoC`,
	"hero__note": `MainHeroSection_hero__note__MrkP5`,
	"hero__note-auth": `MainHeroSection_hero__note-auth__ri91Z`
};
export default ___CSS_LOADER_EXPORT___;
